(function () {

  angular.module('SitesProvider', [])

    .factory('FolderModel', function ($q, $http, TenantListService, uuid) {
      return function (siteResource, evaluate) {
        const folderModel = {
          type: getType(siteResource),
          icon: getIcon(siteResource),
          name: siteResource.name,
          level: getLevel(siteResource),
          id: getId(siteResource),
          parentId: getParentId(siteResource),
          path: siteResource.path,
          setupFinished: siteResource.setupFinished,
          siteRequirements: evaluate ? evaluateSiteRequirements(siteResource) : {},
          ancestorIds: getAncestorIds(siteResource),
          embedded: siteResource._embedded || {},
          siteAdminGroup: formatAdminGroupsToArray(siteResource),
          networkData: prepareNetworks(siteResource),
          network: formatNetworksToArray(siteResource),
          childPath: siteResource.childPath,
          children: siteResource.type === 'COLLECTION' ? [] : null,
          links: siteResource._links,
          info: siteResource
        };

        function getType(siteResource) {
          switch (siteResource.type) {
            case 'COLLECTION':
              return 'folder';
            case 'SINGLE':
              return 'file';
          }
          return undefined;
        }

        function getIcon(siteResource) {
          switch (siteResource.type) {
            case 'COLLECTION':
              return 'icon-folder';
            case 'SINGLE':
              return 'icon-pin';
          }
          return undefined;
        }

        function getId(siteResource) {
          const url = siteResource._links.self.href;
          const index = url.lastIndexOf('/');
          return url.substring(index + 1);
        }

        function getParentId(siteResource) {
          const index = siteResource.path.lastIndexOf('/');
          return siteResource.path.substring(index + 1) || undefined;
        }

        function getLevel(siteResource) {
          return (siteResource.path === '/') ? 0 : siteResource.path.substring(1).split('/').length;
        }

        function evaluateSiteRequirements(siteResource) {
          const siteRequirements = {
            hasSiteAdmin: !!siteResource._links['px:siteAdminGroup'],
            hasNetwork: !!siteResource._links['px:network'],
            networkHasGateway: hasAnyNetworkGateway(siteResource),
            networkHasCompletedDiscovery: hasAnyNetworkLastDiscoveryCompleted(siteResource)
          };
          siteRequirements.setupFinished = hasSetupFinished(siteRequirements);
          if (siteRequirements.setupFinished && !siteResource.setupFinished) {
            const patch = [{
              op: 'replace',
              path: '/setupFinished',
              value: true
            }];
            const url = siteResource._links.self.href;
            $http.patch(url, patch)
              .then(function (response) {
              })
              .catch(function () {
              });
          }
          return siteRequirements;
        }

        function hasAnyNetworkGateway(siteResource) {
          return siteResource._embedded.network?.some(network => network.gateways?.length) ?? false;
        }

        function hasAnyNetworkLastDiscoveryCompleted(siteResource) {
          return siteResource._embedded.network?.some(network => network.lastDiscoveryCompleted) ?? false;
        }

        function hasSetupFinished(siteRequirements) {
          return siteRequirements.hasSiteAdmin && siteRequirements.hasNetwork &&
            siteRequirements.networkHasGateway && siteRequirements.networkHasCompletedDiscovery;
        }

        function getAncestorIds(siteResource) {
          return (siteResource.path === '/') ? [] : siteResource.path.substring(1).split('/');
        }

        function formatAdminGroupsToArray(siteResource) {
          if (siteResource._links['px:siteAdminGroup']) {
            if (angular.isArray(siteResource._links['px:siteAdminGroup'])) {
              return siteResource._links['px:siteAdminGroup'];
            } else {
              return [siteResource._links['px:siteAdminGroup']];
            }
          }
          return [];
        }

        function prepareNetworks(siteResource) {
          if (siteResource._embedded?.network) {
            const networks = siteResource._embedded.network;
            networks.forEach(network => {
              network.open = false;
              network.type = 'network';
              network.loadedPrinters = null;
            });
            return networks.sort(function (a, b) {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
          }
          return null;
        }

        function formatNetworksToArray(siteResource) {
          if (siteResource._links['px:network']) {
            if (angular.isArray(siteResource._links['px:network'])) {
              return siteResource._links['px:network'];
            } else {
              return [siteResource._links['px:network']];
            }
          }
          return [];
        }

        folderModel.moveSite = function (site, parentPath) {
          const deferred = $q.defer();
          const data = {
            targetParentPath: parentPath || '/'
          };
          if (site.info.type === 'COLLECTION' && site.info.path === '/' && data.targetParentPath === '/') {
            deferred.reject({ data: { errorCode: 'CANNOT_MOVE_FOLDER_TO_ROOT' } });
          } else {
            const url = site.links['px:move'].href;
            $http.post(url, data)
              .then(function (response) {
                deferred.resolve(response);
              })
              .catch(function (response) {
                deferred.reject(response);
              });
          }
          return deferred.promise;
        };

        folderModel.renameSite = function (name) {
          const deferred = $q.defer();
          const patch = [{
            op: 'replace',
            path: '/name',
            value: name
          }];
          $http.patch(folderModel.links.self.href, patch)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.createSiteInTree = function (name, type) {
          const deferred = $q.defer();
          const newSite = {
            name,
            path: folderModel.childPath,
            type
          };
          const url = TenantListService.currentTenant.info._links['px:sites'].href;
          $http.post(url, newSite)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.addManagerGroupsToSite = function (groups) {
          const deferred = $q.defer();
          const patch = groups.map(group => {
            return {
              op: 'add',
              path: '/siteAdminGroup/-',
              value: group.info._links.self.href
            };
          });
          $http.patch(folderModel.links.self.href, patch)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.removeSiteAdminGroup = function (group) {
          const deferred = $q.defer();
          const index = folderModel.siteAdminGroup.findIndex(adminGroup => adminGroup.href === group._links.self.href);
          const patch = [
            {
              op: 'test',
              path: '/siteAdminGroup/' + index,
              value: group._links.self.href
            },
            {
              op: 'remove',
              path: '/siteAdminGroup/' + index
            }
          ];
          $http.patch(folderModel.links.self.href, patch)
            .then(function (response) {
              folderModel.siteAdminGroup.splice(index, 1);
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.addNetworksToSite = function (networks) {
          const deferred = $q.defer();
          const patches = networks.map(network => {
            return {
              id: uuid.v4(),
              url: network.info._links.self.href,
              httpMethod: 'PATCH',
              contentType: 'application/json-patch+json',
              payload: [{
                op: folderModel.network.length > 0 ? 'replace' : 'add',
                path: '/siteId',
                value: folderModel.id
              }]
            };
          });
          const batch = {
            batchOperations: patches,
            reference: 'NETWORK_SITES_UPDATED'
          };
          const url = TenantListService.currentTenant.info._links['px:batch'].href + '?strict=true';
          $http.post(url, batch)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.removeNetworkFromSite = function (network) {
          const deferred = $q.defer();
          const patch = [{
            op: 'remove',
            path: '/site'
          }];
          $http.patch(network._links.self.href, patch)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.getSiteWithEmbeddedResources = function () {
          const deferred = $q.defer();
          const url = folderModel.links.self.href + '?embed=GROUP,NETWORK';
          $http.get(url)
            .then(function (response) {
              deferred.resolve(response.data._embedded);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.forceQuitSetupGuide = function () {
          const deferred = $q.defer();
          const patch = [{
            op: 'replace',
            path: '/setupFinished',
            value: true
          }];
          const url = folderModel.links.self.href;
          $http.patch(url, patch)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        folderModel.deleteSite = function () {
          const deferred = $q.defer();
          const url = folderModel.links.self.href;
          $http.delete(url)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (response) {
              deferred.reject(response);
            });
          return deferred.promise;
        };

        return folderModel;
      };

    })

    .factory('SiteTreeModel', function (FolderModel) {

      return function (siteResources) {
        const folderModels = convertSiteResourcesToFolderModels(siteResources);
        const siteTree = constructSiteTree(folderModels);
        sortSiteTree(siteTree);
        return { siteTreeFolders: siteTree };
      };

      function convertSiteResourcesToFolderModels(siteResources) {
        return siteResources.map(siteResource => new FolderModel(siteResource));
      }

      function constructSiteTree(folderModels) {
        const roots = [];
        const map = {};
        folderModels.forEach(function (folderModel, index) {
          map[folderModel.id] = index;
        });
        folderModels.forEach(function (folderModel) {
          if (folderModel.parentId) {
            folderModels[map[folderModel.parentId]].children.push(folderModel);
          } else {
            roots.push(folderModel);
          }
        });
        return roots;
      }

      function sortSiteTree(children) {
        children.sort((child1, child2) => {
          if (child1.type === child2.type) {
            return child1.name.localeCompare(child2.name);
          } else {
            return child1.type === 'folder' ? -1 : 1;
          }
        });
        children.forEach((child) => {
          if (child.children?.length) {
            sortSiteTree(child.children);
          }
        });
      }

    })

    .factory('SitesListPaging', function () {
      return function () {
        return {
          pagingCriteria: {
            page: undefined,           // optional, integer, backend default is 0
            pageSize: undefined,       // optional, integer, backend default is 1000000
            sort: undefined,           // optional, string ('NAME'), backend default is 'NAME'
            direction: undefined,      // optional, string ('ASC' or 'DESC'), backend default is 'ASC'
            match: undefined,          // optional, string
            sites: undefined,          // optional, array of strings (UUIDs)
            path: undefined,           // optional, string
            pathPrefix: undefined,     // optional, string
            type: undefined,           // optional, string ('SINGLE' or 'COLLECTION')
            siteAdminGroup: undefined  // optional, array of strings (UUIDs)
          }
        };
      };
    })

    .service('SitesProviderService', function ($q, $http, TenantListService, SiteTreeModel, FolderModel) {

      // TODO: Replace usage of this function with getSitesPaged()
      this.getSitesAllSites = function () {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:sites'].href;
        $http.get(url)
          .then(function (response) {
            const sites = {};
            if (response.data._embedded) {
              sites.list = response.data._embedded['px:siteResources'];
              sites.tree = new SiteTreeModel(sites.list);
            }
            deferred.resolve(sites);
          })
          .catch(function (response) {
            deferred.reject(response);
          });
        return deferred.promise;
      };

      this.getSitesPaged = function (sitesListPaging, embed) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:sites'].href;
        const config = { params: { ...sitesListPaging.pagingCriteria, embed } };
        $http.get(url, config)
          .then(function (response) {
            const siteResources = response.data._embedded?.['px:siteResources'] || [];
            const folderModels = siteResources.map(siteResource => new FolderModel(siteResource));
            deferred.resolve({ page: response.data.page, sites: folderModels });
          })
          .catch(function (response) {
            deferred.reject(response.data);
          });
        return deferred.promise;
      };

      this.getSiteOnly = function (url) {
        const deferred = $q.defer();
        $http.get(url)
          .then(function (response) {
            const siteResource = response.data;
            const folderModel = new FolderModel(siteResource);
            deferred.resolve(folderModel);
          })
          .catch(function (response) {
            deferred.reject(response);
          });
        return deferred.promise;
      };

      this.getSite = function (url) {
        const deferred = $q.defer();
        url += '?embed=GROUP,NETWORK';
        $http.get(url)
          .then(function (response) {
            const siteResource = response.data;
            const folderModel = new FolderModel(siteResource, true);
            setIconsOnEmbeddedResources(folderModel);
            if (folderModel.parentId) {
              getSiteAncestors(folderModel.ancestorIds)
                .then(function (ancestors) {
                  folderModel.ancestors = ancestors;
                  deferred.resolve(folderModel);
                })
                .catch(function () {
                });
            } else {
              folderModel.ancestors = [];
              deferred.resolve(folderModel);
            }
          })
          .catch(function (response) {
            deferred.reject(response);
          });
        return deferred.promise;
      };

      function setIconsOnEmbeddedResources(folderModel) {
        angular.forEach(folderModel.embedded.network, function (network) {
          network.icon = 'icon-correct-network';
        });
        angular.forEach(folderModel.embedded.siteAdminGroup, function (adminGroup) {
          adminGroup.icon = 'icon-site-admin-2';
        });
      }

      function getSiteAncestors(ancestorIds) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:sites'].href;
        $http.get(url, { params: { sites: ancestorIds } })
          .then(function (response) {
            const ancestors = response.data._embedded['px:siteResources']
              .map(siteResource => new FolderModel(siteResource))
              .sort((a, b) => ancestorIds.indexOf(a.id) - ancestorIds.indexOf(b.id));
            deferred.resolve(ancestors);
          })
          .catch(function (response) {
            deferred.reject(response);
          });
        return deferred.promise;
      }

      this.createSiteTreeRootItem = function (name, type) {
        const deferred = $q.defer();
        const rootItem = {
          path: '/',
          name,
          type: type === 'folder' ? 'COLLECTION' : 'SINGLE'
        };
        const url = TenantListService.currentTenant.info._links['px:sites'].href;
        $http.post(url, rootItem)
          .then(function (response) {
            deferred.resolve(response);
          })
          .catch(function (response) {
            deferred.reject(response);
          });
        return deferred.promise;
      };

    });

})();
